var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5857 9.35071L1.01474 0.779488C0.719033 0.645206 0.366184 0.725204 0.160475 0.979484C-0.046663 1.23376 -0.0538057 1.59518 0.143332 1.8566L6.25033 9.99926L0.143332 18.1419C-0.0538057 18.4033 -0.046663 18.7662 0.159046 19.019C0.297614 19.1919 0.504752 19.2847 0.714747 19.2847C0.816173 19.2847 0.917599 19.2633 1.01331 19.219L19.5843 10.6478C19.8386 10.5307 20 10.2778 20 9.99926C20 9.7207 19.8386 9.46785 19.5857 9.35071Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabArrow);
export default __webpack_public_path__ + "static/media/tab-arrow.3210568c083036e200a0ecd91a944c68.svg";
export { ForwardRef as ReactComponent };